

























































































































import Vue from 'vue'
import { getEventsSubscriptions, exportCsv, exportCsvByGuestCategory, patchSubscriptionCheckIn, deleteSubscription} from '@/modules/event/subscription.service';
import { getEventWithGuestCategoryCounters,getEventGuestCategories } from '@/modules/event/event.service';
import { UserRoles } from '@/modules/auth/auth.model';
import SubscriptionGuestAnswers from '@/components/SubscriptionGuestAnswers';

export default Vue.extend({
    name: 'EventSubscribedList',
    components: { SubscriptionGuestAnswers },
    props: ['formTitle'],
    data: () => ({
      msgError: '',
      msgSuccess: '',
      eventId: 0,
      eventData: {
        name:'',
        date:'',
        dateString: '',
        paymentEnabled:false,
      },
      subscriptionsData:  [] as any[],
      search: '',
      selectedLines: [] as any[],
      eventGuestCategories: [] as any[],
      eventCounter: {},
      isUser: false,
      isSiteManager: false,
      isAdmin: false,
      confirmDialog:false,
      subscriptionToDelete:{}
    }),
    computed: {
      tableHeaders() {
        const headers = [
          { text: 'Nom',value: 'lastName' },
          { text: 'Prénom', value: 'firstName' },
          { text: 'Email',value: 'email' },
          { text: 'Eglise',value: 'organization' },
          { text: 'Total', value: 'guests.length' },
          { text: 'Présent', value: 'checkedIn',filterable: false },
          { text: 'Heure d\'arrivée', value: 'checkInTimestamp' ,filterable: false},
        ];
        if (this.eventData.paymentEnabled){
          headers.push({ text: 'Moyen de paiement', value: 'paymentOptions.type',filterable: false })
          headers.push({ text: 'Montant frais', value: 'paymentAmount',filterable: false })
          headers.push({ text: 'Statut paiement', value: 'paymentStatus',filterable: false })
        }

        headers.push({ text: 'Actions', value: 'actions',filterable: false })

        return headers;
      },
    },
    mounted() {
      this.getEventSubscriptionData();
      this.getEventData();
      const role = localStorage.getItem('user-role');
      if (role === UserRoles.SITEMNGR.key){
        this.isSiteManager = true;
      }else if (role === UserRoles.ADMIN.key){
        this.isAdmin = true;
      }else if (role === UserRoles.USER.key){
        this.isUser = true;
      }
    },
    methods: {
      printGuests(guests){
        let guestsString = "";
        guests.forEach(guest => {
          if (guestsString != "") guestsString += ', '
          guestsString += guest.firstName + ' ' + guest.lastName;
        });
        return guestsString;
      },
      deleteSelectedSubscription(){
        if (this.subscriptionToDelete.id){
          deleteSubscription(this.subscriptionToDelete.id).then(res => {
            if (res.data){
              this.msgError="";
              this.subscriptionToDelete={};
              this.confirmDialog=false;
              this.getEventSubscriptionData();
              this.getEventData();
            }else if (res.error){
              this.msgError = 'Erreur dans la suppression de l\'inscription';
            }
          });
        }else{
          this.msgError = 'Aucune inscription a supprimer';

        }
      },
      generateDate(dateString: any){
        const date = new Date(dateString);
        return date.getDate()+'/'+(date.getMonth()+1)+'/'+date.getFullYear()+' - '+date.getHours()+':'+date.getMinutes();
      },
      backToEvent(){
        this.$router.push('/evenement/gestion?id='+this.eventId);
      },
      checkIn(id: number){
        if (id != 0){
          patchSubscriptionCheckIn(id).then(res => {
              if (res.data){
                this.getEventData();
                this.getEventSubscriptionData();
              }else if (res.error){
                this.msgError = 'Erreur dans la modification de l\'inscription';
              }
            });
        }else{
          this.msgError = 'Erreur : aucune inscription trouvée pour enregistrement';
        }
      },
      editSubscription(id: number){
        this.$router.push('/inscription?id_event='+this.eventId+'&id_subscription='+id);        
      },
      newSubscription(){
        this.$router.push('/inscription?id_event='+this.eventId);        
      },
      exportCsv(){
        exportCsv(this.eventId);
      },
      exportCsvByGuestCategory(guestCategoryId: number, eventGuestCategoryName: string){
        exportCsvByGuestCategory(this.eventId,guestCategoryId,eventGuestCategoryName);
      },
      getEventData(){
        if (this.$route.query.id){
          this.eventId = parseInt(this.$route.query.id?this.$route.query.id:'');
          getEventWithGuestCategoryCounters(this.eventId).then(res => {
            if (res.data){
              if (document && document.title) document.title = (res.data.event&&res.data.event.name)?(res.data.event.name+' LePhare'):'Evénement LePhare&LaSource';
              this.eventData = res.data.event;
              this.eventCounter = res.data.counters;              
              const date = new Date(this.eventData.date);
              this.eventData.dateString = ((date.getDate()<10)?('0'+date.getDate()):date.getDate())+'/'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'/'+date.getFullYear();
            }else if (res.error){
              this.msgError = 'Erreur dans la recupération de l\'événement.'
            }
            getEventGuestCategories(this.eventId).then(res => {
              if (res.data){
                this.eventGuestCategories = res.data;
              }else if (res.error){
                this.msgError = 'Erreur dans la recupération de l\'événement.'
              }
            });
          });
        }
      },
      getEventSubscriptionData(){
        if (this.$route.query.id){
          this.eventId = parseInt(this.$route.query.id?this.$route.query.id:'');
          getEventsSubscriptions(this.eventId).then(res => {
            if (res.data){
              this.subscriptionsData = res.data;
              this.subscriptionsData.forEach(subscription => {
                subscription.guestsString = this.printGuests(subscription.guests);
              });
            }else if (res.error){
              this.msgError = 'Erreur dans la recupération de l\'événement.'
            }
          });
        }
      },
      resetData(){
        this.subscriptionsData = [];
        this.msgError = '';
        this.msgSuccess = '';
        this.subscriptionToDelete = {};
      }
    }
  })
